import { IconButton, SearchInput, Spinner } from '@ds';
import { MdClose } from 'react-icons/md';
import { ReactNode } from 'react';
import { groupByOrganType } from '../utils';
import { CaseDuplicateType } from '@/api/apis/case';
import { CaseDuplicateItem } from './CaseDuplicateItem';

export type CaseDuplicatesContentProps = {
  isLoading: boolean;
  filteredDuplicates: CaseDuplicateType[];
  searchValue: string;
  setSearchValue: (val: string) => void;
  onItemClick: (duplicate: CaseDuplicateType) => void;
  triggerType: 'click' | 'hover';
  withSearch: boolean;
  className?: string;
  onClose?: () => void;
};

export const CaseDuplicatesContent = ({
  isLoading,
  filteredDuplicates,
  searchValue,
  setSearchValue,
  onItemClick,
  triggerType,
  withSearch,
  className = '',
  onClose,
}: CaseDuplicatesContentProps) => {
  const renderDuplicateContent = (): ReactNode => {
    if (isLoading) return <Spinner />;
    if (filteredDuplicates.length === 0) {
      return <div className="text-m-sb text-base-20 py-2 pl-1">No matches found</div>;
    }

    return Object.entries(groupByOrganType(filteredDuplicates)).map(([organType, duplicateGroup]) => (
      <div className="mb-1.5 bg-white p-1 rounded" key={organType}>
        <div className="flex flex-col gap-1">
          {duplicateGroup.map((duplicate) => (
            <CaseDuplicateItem key={duplicate.caseId} duplicate={duplicate} onClick={() => onItemClick(duplicate)} />
          ))}
        </div>
      </div>
    ));
  };

  return (
    <div className={`bg-base-80 rounded-lg shadow-md w-[240px] p-2 scroll scroll-sm ${className}`}>
      <div className="pb-2">
        <div className="flex items-center justify-between">
          <span className="text-m-sb text-base-20 pt-1">Case Duplicates</span>
          {triggerType === 'click' && (
            <IconButton
              size="xs"
              variant="light"
              onClick={onClose}
              startContent={<MdClose size={18} />}
              aria-label="Close"
            />
          )}
        </div>
        {withSearch && (
          <SearchInput
            inputWrapperClassName="border-none bg-base-60 rounded-[8px] mt-2"
            inputClassName="placeholder:text-base-30"
            placeholder="Search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        )}
      </div>
      <div className="max-h-[400px] overflow-y-auto pr-1">{renderDuplicateContent()}</div>
    </div>
  );
};
